/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const OnboardingDatapointUpdate = core.serialization.object({
    source: core.serialization.string().optional(),
    data: core.serialization.any().optional(),
});
